import React, { useEffect, useState } from "react";
import { Button, Col, Form, Card, CardBody, CardFooter, CardHeader, Row } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { Alert, Spin } from "antd";
import { LockOutlined, EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import FormField from "../../../Components/Common/Form/FormField";
import { updatePassword } from "../../Auth/services/authApi";

const UpdatePassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("L'email est invalide").required("L'email est obligatoire"),
    newPassword: Yup.string()
      .min(8, "Le mot de passe doit contenir au moins 8 caractères")
      .matches(/[A-Z]/, "Le mot de passe doit contenir une majuscule")
      .matches(/[0-9]/, "Le mot de passe doit contenir un chiffre")
      .required("Le nouveau mot de passe est obligatoire"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], "Les mots de passe doivent être identiques")
      .required("Merci de confirmer le nouveau mot de passe"),
  });

  const initialValues = {
    email: "",
    newPassword: "",
    confirmPassword: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        await updatePassword({
          email: values.email,
          newPassword: values.newPassword,
        });
        toast.success("Le mot de passe a été modifié avec succès 🎉",
          setTimeout(() => {
          }, 50000)
        );
        formik.resetForm();
      } catch (error) {
        toast.error(`Erreur: ${error?.message || error}`);
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <Card>
      <CardHeader className="bg-info-subtle p-3 text-center">
        Modification de mot de passe <LockOutlined />
      </CardHeader>
      <Form onSubmit={formik.handleSubmit}>
        <CardBody>
          <Row>
            <Col md={12} className="position-relative">
              <FormField 
                label="Adresse mail" 
                name="email" 
                formik={formik} 
                type="email"
                colSize={12} 
                placeholder="Entrez ton adresse mail lié à votre compte" 
              />
            </Col>
            <Col md={6} className="position-relative">
              <FormField 
                label="Nouveau mot de passe" 
                name="newPassword" 
                formik={formik} 
                type={showNewPassword ? "text" : "password"} 
                colSize={12} 
                placeholder="Entrez le nouveau" 
              />
              <div
                onClick={() => setShowNewPassword(!showNewPassword)}
                style={{ position: 'absolute', right: '20px', top: '40px', cursor: 'pointer' }}
              >
                {showNewPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
              </div>
            </Col>
            <Col md={6} className="position-relative">
              <FormField 
                label="Confirmer le mot de passe" 
                name="confirmPassword" 
                formik={formik} 
                type={showConfirmPassword ? "text" : "password"} 
                colSize={12} 
                placeholder="Confirmer le nouveau" 
              />
              <div
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                style={{ position: 'absolute', right: '20px', top: '40px', cursor: 'pointer' }}
              >
                {showConfirmPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
              </div>
            </Col>
          </Row>
        </CardBody>
        <CardFooter className="text-end">
          <Button
            type="submit"
            className="btn-soft-success"
            disabled={isLoading || !formik.isValid || !formik.dirty}
          >
            {isLoading ? <Spin size="small" /> : "Modifier"}
          </Button>
        </CardFooter>
      </Form>
    </Card>
  );
};

export default UpdatePassword;
